import { AuthGuardService } from 'src/app/auth-guard.service';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BalanceDetailsSearchComponent } from './balance-details-search/balance-details-search.component';
import { PaymentStatementSearchComponent } from './payment-statement-search/payment-statement-search.component';
import { PaymentStatementDetailsSearchComponent } from './payment-statement-details-search/payment-statement-details-search.component';
import { TeamBalanceDetailsSearchComponent } from './team-balance-details-search/team-balance-details-search.component';

const routes: Routes = [
  {
    path: 'search-balance-details',
    component: BalanceDetailsSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-balance-details/:agentId',
    component: BalanceDetailsSearchComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'search-payment-statement',
    component: PaymentStatementSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-payment-statement/:id',
    component: PaymentStatementSearchComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'payment-statement-details/:id',
    component: PaymentStatementDetailsSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-team-balance-details',
    component: TeamBalanceDetailsSearchComponent,
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class FinanceRoutingModule {}
